import React, { useEffect } from 'react';

/* ---------------------------------- mui ---------------------------------- */

import { Container } from '@mui/system';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

/* -------------------------------- component ------------------------------- */
import { ParticipantCard } from '../../components/ParticipantCard/ParticipantCard';
import { cardsContent } from '../../components/ParticipantCard/participantCardData'

/* ---------------------------------- style --------------------------------- */
import './InfoPage.css'
import { Timer } from '../../components/Timer/Timer';
import { useTypedSelector } from '../../hook/useTypedSelector';
import { useActions } from '../../hook/useAction';
import { TeemCard } from '../../components/TeemCard/TeemCard';
import MoneyCard from '../../components/MoneyCard/MoneyCard';


const InfoPage: React.FC = () => {

   // деструкрурізація (свій хук)
   const { error, loading, data } = useTypedSelector(state => state.Mono)
   // Баланс с монобанка
   const balance = data && data.jars && data.jars[0] && data.jars[0].balance

   // Убираем копейки
   let balanceNew = balance;
   balanceNew = Math.floor(balanceNew / 100);

   //замість кодного разу диспатч)
   const { fetchMono } = useActions()

   useEffect(() => {
      fetchMono()
   }, [])

   return (
      <div id='info_page' className='info_page'>
         {/* таймер при начале конкурса: перейти внутрь компонента таймер, установить дату запуска */}
         <Timer />
      
         <MoneyCard balanceNew={balanceNew}/>
         {/* Ждите новый ивент */}
         {/* <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
            <h2 className='infoPage_title'>Expect new events!</h2>
         </Box> */}
         {/* карточка команды */}
         <TeemCard />

         {/*ЛОГИКА КАРТОЧЕК УЧАСНИКОВ С ПЕРВОГО ИВЕНТА */}
         {/* maxWidth="xl" */}
         {/* <Container fixed sx={{ paddingBottom: 8 }}>
            <Grid container spacing={4}  >
               {cardsContent.map(cardContent => (
                  <Grid item xs={12} sm={6} md={3} key={cardContent.id}>
                     <ParticipantCard cardContent={cardContent} />
                  </Grid>
               ))}
            </Grid>
         </Container> */}

         <a href="#info_page">
            <div className='btn_up_info_page'>
               <img src="./img/up.png" alt="icon" />
            </div>
         </a>
      </div>
   )
}

export default InfoPage;

